import { useMutation, useQueryClient } from "react-query";

import QAService from "@services/questionAnswer-service";
import { questionAnswerQueryKeys } from "./queryKeys";

export const useUpdateQuestionAnswerMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ id, data }: { id: string; data: Object }) => {
      return new Promise((resolve, reject) => {
        QAService.update(id, data, (err, res) => {
          if (err || !res) {
            return reject(err);
          }
          resolve(res.data);
        });
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(questionAnswerQueryKeys.all);
      },
    }
  );
};
